<template>
	<div id="siteMap">
		<div class="map_area">
			<div class="mapGroup">
				<div class="title"><span @click.stop="jump('/company/')">会社情報</span></div>
				<div class="contentsName"><span @click.stop="jump('/company/#comment')">ご挨拶</span></div>
				<div class="contentsName"><span @click.stop="jump('/company/#info')">会社概要</span></div>
			</div>
			<div class="mapGroup">
				<div class="title"><span @click.stop="jump('/services/')">事業内容</span></div>
				<div class="contentsName"><span @click.stop="jump('/services/#system')">システム開発</span></div>
				<div class="contentsName"><span @click.stop="jump('/services/#webapp')">WEBアプリケーション開発</span></div>
				<div class="contentsName"><span @click.stop="jump('/services/#design')">WEBサイト制作・各種デザイン</span></div>
				<div class="contentsName"><span @click.stop="jump('/services/#consultant')">システムコンサルタント</span></div>
			</div>
			<div class="mapGroup">
				<div class="title"><span @click.stop="jump('/recruit/')">リクルート</span></div>
				<div class="contentsName"><span @click.stop="jump('/recruit/')">採用情報</span></div>
				<div class="title" style="padding-top:30px; padding-bottom:30px;"><span @click.stop="jump('/privacy/')">プライバシーポリシー</span></div>
			</div>
			<div class="mapGroup">
				<div class="title"><span @click.stop="jump('/contact/')">コンタクト</span></div>
				<div class="contentsName"><span @click.stop="jump('/contact/')">お問い合わせ</span></div>
				<div class="title" style="padding-top:30px"><a class="blog" href="https://biibridge-labo.work/" target="_blank" rel="noopener">ブログ</a></div>
			</div>
		</div>
		<div class="social_area">
			<div class="mapGroup">
				<div class="title">ソーシャル</div>
				<div>
					<span style="margin-right:30px;">
						<a href="https://twitter.com/biibridge" target="_blank" rel="noopener" title="twitter">
							<svg viewBox="0 0 2000 1625.36" width="32px" height="32px">
								<path
									d="m 1999.9999,192.4 c -73.58,32.64 -152.67,54.69 -235.66,64.61 84.7,-50.78 149.77,-131.19 180.41,-227.01 -79.29,47.03 -167.1,81.17 -260.57,99.57 C 1609.3399,49.82 1502.6999,0 1384.6799,0 c -226.6,0 -410.328,183.71 -410.328,410.31 0,32.16 3.628,63.48 10.625,93.51 -341.016,-17.11 -643.368,-180.47 -845.739,-428.72 -35.324,60.6 -55.5583,131.09 -55.5583,206.29 0,142.36 72.4373,267.95 182.5433,341.53 -67.262,-2.13 -130.535,-20.59 -185.8519,-51.32 -0.039,1.71 -0.039,3.42 -0.039,5.16 0,198.803 141.441,364.635 329.145,402.342 -34.426,9.375 -70.676,14.395 -108.098,14.395 -26.441,0 -52.145,-2.578 -77.203,-7.364 52.215,163.008 203.75,281.649 383.304,284.946 -140.429,110.062 -317.351,175.66 -509.5972,175.66 -33.1211,0 -65.7851,-1.949 -97.8828,-5.738 181.586,116.4176 397.27,184.359 628.988,184.359 754.732,0 1167.462,-625.238 1167.462,-1167.47 0,-17.79 -0.41,-35.48 -1.2,-53.08 80.1799,-57.86 149.7399,-130.12 204.7499,-212.41"
									style="fill:#bcbcbc"/>
							</svg>
						</a>
					</span>
					<span style="margin-right:30px;">
						<a href="https://www.facebook.com/biibridge/" target="_blank" rel="noopener" title="facebook">
							<svg viewBox="0 -44 300 300" width="44px" height="44px">
								<path d="M234.51,57.86h-169A10.48,10.48,0,0,0,55,68.35v169a10.49,10.49,0,0,0,10.49,10.49h91V174.29H131.72V145.61h24.76V124.46c0-24.54,15-37.9,36.88-37.9a203.18,203.18,0,0,1,22.13,1.13v25.65H200.31c-11.91,0-14.21,5.66-14.21,14v18.31h28.4l-3.7,28.68H186.1v73.58h48.42A10.49,10.49,0,0,0,245,237.38v-169A10.49,10.49,0,0,0,234.51,57.86Z" style="fill:#bcbcbc"/>
							</svg>
						</a>
					</span>
					<span style="margin-right:30px;">
						<a href="https://www.instagram.com/biibridge/" target="_blank" rel="noopener" title="instagram">
							<svg viewBox="0 0 448 512" width="30px" height="32px"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" style="fill:#bcbcbc"/></svg>
						</a>
					</span>
				</div>
			</div>
		</div>
		<div class="copyrightArea"><span class="copyright">Copyright &copy; Biibridge Inc. All rights reserved.</span></div>
	</div>
</template>

<script>
export default {
	methods: {
		jump(path) {
			this.$router.push(path);
		}
	}
}
</script>

<style lang="less" scoped>
#siteMap {
	padding: 60px 80px;
	background-color: #3b3430;
	color: #bcbcbc;
	
	.map_area {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		
		.mapGroup {
			width: 25%;
			
			.title {
				font-weight: bold;
				
				span {
					cursor: pointer;
				}
			}
			
			.contentsName {
				font-size: 0.8rem;
				padding: 10px 0 0 18px;
				
				span {
					cursor: pointer;
				}
			}
		}
		
		.blog {
			color: #bcbcbc;
			text-decoration: none;
		}
	}
	
	.social_area {
		width: 100%;
		margin-top: 60px;
		border-top: 1px solid #5c5c5c;
		
		.mapGroup {
			padding-top: 10px;
			
			.title {
				font-weight: bold;
				
				span {
					cursor: pointer;
				}
			}
		}
	}
	
	.copyrightArea {
		padding: 30px 0 0;
		width: 100%;
		text-align: center;
		
		.copyright {
			display: inline-block;
			font-family:
				"メイリオ", Meiryo,
				"ヒラギノ角ゴ ProN W3",
				"MS UI Gothic",
				"Lucida Grande",
				Tahoma,
				"ヒラギノ丸ゴ Pro W4",
				sans-serif;
			font-size: 0.8rem;
			padding: 0 40px;
			text-align: left;
			color: #bcbcbc;
			margin: 40px 0 22px;
		}
	}
}

@media(max-width:420px) {
	#siteMap {
		padding: 60px 50px;
		
		.map_area {
			flex-direction: column;
			
			.mapGroup {
				width: 100%;
				
				.contentsName {
					&:last-child {
						margin-bottom: 30px;
					}
				}
			}
		}
		
		.copyrightArea {
			.copyright {
				padding: 0;
			}
		}
	}
}
</style>
